import React, {Component, Fragment} from 'react';
import {Trans} from '@lingui/macro';

import s from './WelcomeUser.css';

class WelcomeUser extends Component {
  titleRef = React.createRef();

  componentDidMount() {
    this.titleRef.current.focus();
  }

  render() {
    const {userName} = this.props;

    return (
      <Fragment>
        <h1 ref={this.titleRef} tabIndex="-1" className={s.Title} aria-live="assertive" aria-atomic="true">
          <Trans id="home.welcome">Buongiorno, {userName || 'guest'}.</Trans>
        </h1>
        <div className={s.Divider} />
      </Fragment>
    );
  }
}

export default WelcomeUser;
